import { siteConfig } from "../config/site";

export function FraudWarningBanner() {
  const message = `Always use our secure Repayment on Website Link for loan payments. Do not make direct bank payments to fake UPI links or unauthorised payment links. ${siteConfig.companyName} is not responsible for payments made to other accounts.`;

  return (
    <div className="sticky bottom-0 z-50 w-full overflow-hidden bg-brand-purple-header py-4 font-jakarta text-white">
      <div className="marquee-track flex w-max items-center gap-16">
        {[0, 1].map((i) => (
          <span
            key={i}
            aria-hidden={i === 1}
            className="flex shrink-0 items-center gap-2 whitespace-nowrap px-8 text-[13px]"
          >
            <span className="font-semibold text-amber-300">
              Beware of fraud!
            </span>{" "}
            {message}
          </span>
        ))}
      </div>
      <span className="sr-only">Beware of fraud! {message}</span>
    </div>
  );
}
